import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  AppQueryProvider,
  ApplicationErrorBoundary,
  AuthProvider,
  PermissionProvider,
} from '@beatq/shared';
import { ThemeProvider } from '@beatq/ui';
import '@beatq/ui/styles.css';
import './business-portal.css';
import { App } from './App.js';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApplicationErrorBoundary appName="BeatQ Business" homeHref="/">
      <AppQueryProvider>
        <AuthProvider surface="business">
          <PermissionProvider surface="business">
            <ThemeProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ThemeProvider>
          </PermissionProvider>
        </AuthProvider>
      </AppQueryProvider>
    </ApplicationErrorBoundary>
  </StrictMode>,
);
